const HISTORY_KEY = 'pushupProHistory';

export function addHistoryEntry(date, reps) {
  const history = getHistory();
  history.push({ date, reps });
  localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
}

export function getHistory() {
  try {
    const h = localStorage.getItem(HISTORY_KEY);
    return h ? JSON.parse(h) : [];
  } catch {
    return [];
  }
}

export function clearHistory() {
  localStorage.removeItem(HISTORY_KEY);
} 